module.exports = __webpack_public_path__ + "static/media/rob-rings.2a89ff9c.png";